import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import Lottie from "react-lottie"
import BeingCreative from "../../../assets/lotties/being-creative.json"
import DrivenToGrow from "../../../assets/lotties/driven-to-grow.json"
import PeopleFirst from "../../../assets/lotties/people-first.json"
import PositiveImpact from "../../../assets/lotties/positive-impact.json"

const TitleColumnContent = ({ title, items }) => {

  const animations = {
    "being-creative": BeingCreative,
    "positive-impact": PositiveImpact,
    "driven-to-grow": DrivenToGrow,
    "people-first": PeopleFirst,
  }

  const handleOptions = (style) => {
    return {
      loop: true,
      autoplay: true,
      animationData: animations[style],
      rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
    }
  }

  return (
    <section className="title-column-content">
      <div className="title-column-content__inner">
        <div className="title-column-content__title">
          {title && <h2>{parse(title)}</h2>}
          <div className="line line--horizon center-left"></div>
        </div>

        <div className="title-column-content__wrapper">
          <div className="line line--vertical center-bottom"></div>
          <div className="line line--vertical center-top"></div>
          <div className="line line--horizon center-left"></div>
          <div style={{bottom: 0, top: 'auto'}} className="line line--horizon center-left"></div>

          <div className="title-column-content__items">
            {items?.length > 0 && items?.map((el, i) => (
              <div key={i} className={`title-column-content__item ${!el.title ? "spacing" : ""}`}>
                <div className="content">
                  <div className="icon"><Lottie options={handleOptions(el.icon)} /></div>
                  {el.title && <h3>{parse(el.title)}</h3>}
                  {el.richContent && <StructuredText data={el.richContent} />}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TitleColumnContent

export const query = graphql`
  fragment TitleColumnContentProps on DatoCmsTitleColumnContent {
    ... on DatoCmsTitleColumnContent {
      id
      title
      items {
        title
        richContent {
          value
        }
        icon
      }
    }
  }
`
